import { FC, useState } from "react";
import CustomButton from "ui/Button";
import { ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import CustomDropDownList from "ui/dropDown";
import { getBuyersFilterApi } from "api/common";
import { ContractFilter } from "api/contract";
import { Vessel } from "interface/vessel";
import { CustomInput } from "ui/Input";
import { getVesselFilter } from "api/vessel";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: ContractFilter) => void;
	filterOptions: ContractFilter;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	exportAsPDF,
	...props
}) => {
	const { t } = useTranslation();
	const [tempFilter, setTempFilter] = useState(filterOptions);

	const applyContractId = () => {
		setFilterOptions({
			...filterOptions,
			contractId: tempFilter.contractId,
			take: props.pageSize,
			skip: 0,
		});
	};

	return (
		<div className="filter-container">
			<div className="filter-items contract-filter-items">
				{/*<div style={{ width: "170px" }}>*/}
				{/*	<DatePickerComponent*/}
				{/*		placeholder={t("FromDate")}*/}
				{/*		label={t("FromDate")}*/}
				{/*		format={DATE_FORMAT}*/}
				{/*		className="height-inherit"*/}
				{/*		value={filterOptions.fromDate}*/}
				{/*		onChange={(e) =>*/}
				{/*			setFilterOptions({*/}
				{/*				...filterOptions,*/}
				{/*				fromDate: e.target.value,*/}
				{/*				take: props.pageSize,*/}
				{/*				skip: 0,*/}
				{/*			})*/}
				{/*		}*/}
				{/*	/>*/}
				{/*</div>*/}
				{/*<div style={{ width: "170px" }}>*/}
				{/*	<DatePickerComponent*/}
				{/*		placeholder={t("ToDate")}*/}
				{/*		label={t("ToDate")}*/}
				{/*		className="height-inherit"*/}
				{/*		format={DATE_FORMAT}*/}
				{/*		value={filterOptions.toDate}*/}
				{/*		onChange={(e) =>*/}
				{/*			setFilterOptions({*/}
				{/*				...filterOptions,*/}
				{/*				toDate: e.target.value,*/}
				{/*				take: props.pageSize,*/}
				{/*				skip: 0,*/}
				{/*			})*/}
				{/*		}*/}
				{/*	/>*/}
				{/*</div>*/}
				<div className="contract-filter-field" style={{ width: "170px" }}>
					<CustomInput
						onChange={(e) => setTempFilter({ ...tempFilter, contractId: e })}
						label={t("ContractNoteNumber")}
						placeholder=" "
						value={tempFilter.contractId}
						onKeyDown={(e: any) => {
							if (e.key === "Enter") applyContractId();
						}}
						onBlur={(e) => applyContractId()}
					/>
				</div>
				<div className="contract-filter-field" style={{ width: "170px" }}>
					<CustomDropDownList
						onSelect={(buyer) =>
							setFilterOptions({
								...filterOptions,
								buyerId: buyer.id,
								buyerName: buyer.name,
								buyerLedgerAccountNumber: buyer.id,
								take: props.pageSize,
								skip: 0,
							})
						}
						data={[]}
						value={{
							id: filterOptions.buyerId || null,
						//	name: filterOptions.buyerName || t("ChooseBuyer"),
							name: filterOptions.buyerName || " ",
						}}
						dataItemKey="id"
						textField="name"
						label={t("Buyer")}
						defaultItem={{ id: null, name: t("All") }}
						className="height-inherit"
						filterable={true}
						serverFilter={true}
						serverFilterApi={getBuyersFilterApi}
					/>
				</div>
				<div className="contract-filter-field" style={{ width: "170px" }}>
					<CustomDropDownList
						data={[]}
						filterable={true}
						dataItemKey="id"
						textField="nm"
						label={t("Vessel")}
						value={{
							id: filterOptions.vesselId || null,
						//	nm: filterOptions.vesselName || t("ChooseVessel"),
							nm: filterOptions.vesselName || " ",
						}}
						// label="Velg Fartøy"
						defaultItem={{ id: null, nm: t("All") }}
						onSelect={(vessel: Vessel) => {
							setFilterOptions({
								...filterOptions,
								vesselId: vessel.id,
								vesselName: vessel.id ? vessel.nm : "",
								vesselLedgerAccountNumber: vessel.res as any,
								take: props.pageSize,
								skip: 0,
							});
						}}
						serverFilter={true}
						serverFilterApi={getVesselFilter}
						// popupSettings={{ width: 400 }}
					/>
				</div>

			</div>

			<div className="filter-end-btn contract-filter-end-btn">
				{/*<CustomButton*/}
				{/*	label={"PDF"}*/}
				{/*	onClick={() => exportAsPDF()}*/}
				{/*	iconName={ICON_NAMES.Download}*/}
				{/*/>*/}
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
